import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";
import GoogleAuthRedirect from "../views/auth/GoogleAuthRedirect.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  }
  ,
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { 
      requiresAuth: true,
      keepAlive: true,
      permissions: ['view stats', 'view dashboard', 'view-stats', 'view-dashboard']
    },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { hideLayout: true }
  },
  {
    path: "/google-auth-redirect",
    name: "GoogleAuthRedirect",
    component: GoogleAuthRedirect,
    meta: { requiresAuth: false },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/whatsapp-reports",
    name: "WhatsAppReportList",
    component: () => import("../views/WhatsAppReports/List.vue"),
    meta: { requiresAuth: true, keepAlive: true },
  },
  {
    path: "/whatsapp-reminders",
    name: "WhatsAppReminders",
    component: () => import("../views/WhatsAppReports/Reminders.vue"),
    meta: { requiresAuth: true, keepAlive: true },
  },
  {
    path: "/whatsapp-reports/:id",
    name: "WhatsAppReportDetails",
    component: () => import("../views/WhatsAppReports/Details.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/whatsapp/otp-logs",
    name: "OtpLogs",
    component: () => import("../views/WhatsAppReports/OtpLogs.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/no-access",
    name: "NoAccess",
    component: () => import("../views/NoAccess.vue"),
    meta: { requiresAuth: true },
  },



  //home banners routes
  {
    path: "/home-banners",
    name: "Home Banners",
    component: () => import("../views/HomeBanners/List.vue"),
    meta: { requiresAuth: true, keepAlive: true }
  },
  {
    path: "/home-banners/create",
    name: "HomeBannerCreate",
    component: () => import("../views/HomeBanners/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/home-banners/:id/edit",
    name: "HomeBannerEdit",
    component: () => import("../views/HomeBanners/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //country routes
  {
    path: "/countries",
    name: "Countries",
    component: () => import("../views/Countries/List.vue"),
    meta: { requiresAuth: true, keepAlive: true }
  },
  {
    path: "/countries/create",
    name: "CountryCreate",
    component: () => import("../views/Countries/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/countries/:id/edit",
    name: "CountryEdit",
    component: () => import("../views/Countries/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },


  // Subject routes
  {
    path: "/subjects",
    name: "Subjects",
    component: () => import("../views/Subjects/List.vue"),
    meta: { requiresAuth: true, keepAlive: true, permissions: ['view subjects', 'view-subjects', 'create subjects', 'create-subjects', 'edit subjects', 'edit-subjects'] }
  },
  {
    path: "/subjects/create",
    name: "SubjectCreate",
    component: () => import("../views/Subjects/Create.vue"),
    meta: { requiresAuth: true, permissions: ['create subjects', 'create-subjects'] }
  },
  {
    path: "/subjects/:id/edit",
    name: "SubjectEdit",
    component: () => import("../views/Subjects/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit subjects', 'edit-subjects'] }
  },
  {
    path: "/subjects/:id/view",
    name: "SubjectView",
    component: () => import("../views/Subjects/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view subjects', 'view-subjects'] },
  },
  // Course routes
  {
    path: "/courses",
    name: "Courses",
    component: () => import("../views/Courses/List.vue"),
    meta: { requiresAuth: true, keepAlive: true, permissions: ['view courses', 'view-courses', 'create courses', 'create-courses', 'edit courses', 'edit-courses'] }
  },
  {
    path: "/courses/create",
    name: "CourseCreate",
    component: () => import("../views/Courses/Create.vue"),
    meta: { requiresAuth: true, permissions: ['create courses', 'create-courses'] }
  },
  {
    path: "/courses/:id/edit",
    name: "CourseEdit",
    component: () => import("../views/Courses/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit courses', 'edit-courses'] }
  },
  {
    path: "/courses/:id/view",
    name: "CourseView",
    component: () => import("../views/Courses/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view courses', 'view-courses'] },
  },
  // Course Session routes
  {
    path: "/courses/:courseId/sessions",
    name: "CourseSessionsList",
    component: () => import("../views/CourseSessions/List.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view sessions', 'view-sessions', 'create sessions', 'create-sessions', 'edit sessions', 'edit-sessions'] }
  },
  {
    path: "/courses/:courseId/sessions/:id/view",
    name: "CourseSessionView",
    component: () => import("../views/CourseSessions/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view sessions', 'view-sessions'] }
  },
  {
    path: "/courses/:courseId/sessions/create",
    name: "CourseSessionCreate",
    component: () => import("../views/CourseSessions/Create.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['create sessions', 'create-sessions'] }
  },
  {
    path: "/courses/:courseId/sessions/create-free",
    name: "CourseSessionCreateFree",
    component: () => import("../views/CourseSessions/CreateFree.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['create sessions', 'create-sessions'] }
  },
  {
    path: "/courses/:courseId/sessions/:id/edit",
    name: "CourseSessionEdit",
    component: () => import("../views/CourseSessions/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit sessions', 'edit-sessions'] }
  },
  {
    path: "/courses/:courseId/sessions/:id/edit-free",
    name: "CourseSessionEditFree",
    component: () => import("../views/CourseSessions/EditFree.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit sessions', 'edit-sessions'] }
  },

  // All Course Sessions List (WITHOUT courseId)  🔁 ← كان بيروح لنفس List.vue وده غلط
  {
    path: "/course-sessions",
    name: "AllCourseSessionsList",
    component: () => import("../views/CourseSessions/ListAll.vue"), // <-- مهم
    meta: { requiresAuth: true, keepAlive: true, permissions: ['view sessions', 'view-sessions', 'create sessions', 'create-sessions', 'edit sessions', 'edit-sessions'] }
  },
  {
    path: "/course-sessions/:id/view",
    name: "AllCourseSessionView",
    component: () => import("../views/CourseSessions/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view sessions', 'view-sessions'] }
  },



  // Teacher routes
  {
    path: "/teachers",
    name: "Teachers",
    component: () => import("../views/Teachers/List.vue"),
    meta: { requiresAuth: true, keepAlive: true }
  },
  {
    path: "/teachers/create",
    name: "TeacherCreate",
    component: () => import("../views/Teachers/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/teachers/:id/edit",
    name: "TeacherEdit",
    component: () => import("../views/Teachers/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/teachers/:id/view",
    name: "TeacherView",
    component: () => import("../views/Teachers/View.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/teachers/assign-subjects",
    name: "AssignTeacherToSubject",
    component: () => import("../views/Teachers/AssignTeacherToSubject.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/teachers/detach-subjects",
    name: "DetachTeacherFromSubject",
    component: () => import("../views/Teachers/DetachTeacherFromSubject.vue"),
    meta: { requiresAuth: true },
  },

    // Session Question routes
  {
    path: "/question-bank/session-questions",
    name: "SessionQuestionsList",
    component: () => import("../views/QuestionBank/SessionQuestions/List.vue"),
    meta: { requiresAuth: true, permissions: ['view questions', 'view-questions', 'create questions', 'create-questions', 'edit questions', 'edit-questions'] }
  },
  {
    path: "/question-bank/session-questions/create",
    name: "SessionQuestionCreate",
    component: () => import("../views/QuestionBank/SessionQuestions/Create.vue"),
    meta: { requiresAuth: true, permissions: ['create questions', 'create-questions'] }
  },
  {
    path: "/question-bank/session-questions/:id/edit",
    name: "SessionQuestionEdit",
    component: () => import("../views/QuestionBank/SessionQuestions/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit questions', 'edit-questions'] }
  },
  {
    path: "/question-bank/session-questions/:id/view",
    name: "SessionQuestionView",
    component: () => import("../views/QuestionBank/SessionQuestions/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view questions', 'view-questions'] }
  },

  // Session Question Options routes
  {
    path: "/question-bank/session-question-options",
    name: "SessionQuestionOptionsList",
    component: () => import("../views/QuestionBank/SessionQuestionOptions/List.vue"),
    meta: { requiresAuth: true, permissions: ['view question options', 'view-question-options', 'create question options', 'create-question-options', 'edit question options', 'edit-question-options'] }
  },
  {
    path: "/question-bank/session-question-options/create",
    name: "SessionQuestionOptionCreate",
    component: () => import("../views/QuestionBank/SessionQuestionOptions/Create.vue"),
    meta: { requiresAuth: true, permissions: ['create question options', 'create-question-options'] }
  },
  {
    path: "/question-bank/session-question-options/:id/edit",
    name: "SessionQuestionOptionEdit",
    component: () => import("../views/QuestionBank/SessionQuestionOptions/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit question options', 'edit-question-options'] }
  },
  {
    path: "/question-bank/session-question-options/:id/view",
    name: "SessionQuestionOptionView",
    component: () => import("../views/QuestionBank/SessionQuestionOptions/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view question options', 'view-question-options'] }
  },

  // Session Submission routes
  {
    path: "/question-bank/session-submissions",
    name: "SessionSubmissionsList",
    component: () => import("../views/QuestionBank/SessionSubmissions/List.vue"),
    meta: { requiresAuth: true, permissions: ['view answers', 'view-answers', 'create answers', 'create-answers', 'edit answers', 'edit-answers'] }
  },
  {
    path: "/question-bank/session-submissions/:id/edit",
    name: "SessionSubmissionEdit",
    component: () => import("../views/QuestionBank/SessionSubmissions/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit answers', 'edit-answers'] }
  },
  {
    path: "/question-bank/session-submissions/:sessionId/:id/view",
    name: "SessionSubmissionView",
    component: () => import("../views/QuestionBank/SessionSubmissions/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view answers', 'view-answers'] }
  },

  {
    path: "/question-bank/session-answers/create",
    name: "SessionAnswerCreate",
    component: () => import("../views/QuestionBank/SessionAnswers/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/question-bank/session-answers/:id/edit",
    name: "SessionAnswerEdit",
    component: () => import("../views/QuestionBank/SessionAnswers/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/question-bank/session-answers/:id/view",
    name: "SessionAnswerView",
    component: () => import("../views/QuestionBank/SessionAnswers/View.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  // Homework routes
  {
    path: "/homework",
    name: "HomeworkList",
    component: () => import("../views/Homework/List.vue"),
    meta: { requiresAuth: true, permissions: ['view homework', 'view-homework', 'create homework', 'create-homework', 'edit homework', 'edit-homework'] }
  },
  {
    path: "/homework/create",
    name: "HomeworkCreate",
    component: () => import("../views/Homework/Create.vue"),
    meta: { requiresAuth: true, permissions: ['create homework', 'create-homework'] }
  },
  {
    path: "/homework/:id/edit",
    name: "HomeworkEdit",
    component: () => import("../views/Homework/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit homework', 'edit-homework'] }
  },
  {
    path: "/homework/:id/view",
    name: "HomeworkView",
    component: () => import("../views/Homework/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view homework', 'view-homework'] }
  },
  //users routes

  // Admin routes
  {
    path: "/admin/wallet/charge/:id",
    name: "AdminStudentCreditWallet",
    component: () => import("../views/Admin/StudentCreditWallet.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view wallets', 'view-wallets', 'manage wallets', 'manage-wallets', 'manage wallet', 'manage-wallet'] }
  },
  {
    path: "/admin/wallet/balance/:userId",
    name: "AdminStudentBalance",
    component: () => import("../views/Admin/StudentBalance.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view wallets', 'view-wallets', 'manage wallets', 'manage-wallets', 'manage wallet', 'manage-wallet'] }
  },

  // Reservation routes
  {
    path: "/admin/reservations",
    name: "ReservationsIndex",
    component: () => import("../views/Admin/ReservationsIndex.vue"),
    meta: { requiresAuth: true, permissions: ['view reservations', 'view-reservations'] }
  },
  {
    path: "/admin/reservations/calendar",
    name: "ReservationCalendar",
    component: () => import("../views/Admin/ReservationCalendar.vue"),
    meta: { requiresAuth: true, permissions: ['view reservations', 'view-reservations'] }
  },
  {
    path: "/admin/reservations/create",
    name: "ReservationCreate",
    component: () => import("../views/Admin/ReservationCreate.vue"),
    meta: { requiresAuth: true, permissions: ['create reservations', 'create-reservations'] }
  },
  {
    path: "/admin/reservations/custom",
    name: "CustomReservationCreate",
    component: () => import("../views/Admin/CustomReservationCreate.vue"),
    meta: { requiresAuth: true, permissions: ['create reservations', 'create-reservations'] }
  },
  {
    path: "/admin/reservations/:id",
    name: "ReservationShow",
    component: () => import("../views/Admin/ReservationShow.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view reservations', 'view-reservations'] }
  },

  // User routes (Admin)
  {
    path: "/admin/users",
    name: "Users",
    component: () => import("../views/Admin/Users/List.vue"),
    meta: { requiresAuth: true, permissions: ['view users', 'view-users', 'create users', 'create-users', 'edit users', 'edit-users'] }
  },
  {
    path: "/admin/users/create",
    name: "UserCreate",
    component: () => import("../views/Admin/Users/Create.vue"),
    meta: { requiresAuth: true, permissions: ['create users', 'create-users'] }
  },
  {
    path: "/admin/users/:id/view",
    name: "UserView",
    component: () => import("../views/Admin/Users/View.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view users', 'view-users'] },
  },
  {
    path: "/admin/users/:id/add-academic-year",
    name: "AddAcademicYear",
    component: () => import("../views/Admin/Users/AddAcademicYear.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit users', 'edit-users'] },
  },
  {
    path: "/admin/users/add-academic-year",
    name: "AddAcademicYearGeneral",
    component: () => import("../views/Admin/Users/AddAcademicYear.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit users', 'edit-users'] },
  },
  {
    path: "/admin/moderators",
    name: "Moderators",
    component: () => import("../views/Admin/Users/ModeratorList.vue"),
    meta: { requiresAuth: true, permissions: ['view users', 'view-users'] }
  },
  {
    path: "/admin/moderators/create",
    name: "ModeratorCreate",
    component: () => import("../views/Admin/Users/ModeratorCreate.vue"),
    meta: { requiresAuth: true, permissions: ['create users', 'create-users'] }
  },

  // Notification routes
  {
    path: "/admin/notifications/manual",
    name: "ManualNotification",
    component: () => import("../views/Admin/Notifications/ManualNotification.vue"),
    meta: { requiresAuth: true, permissions: ['send notifications', 'send-notifications'] }
  },
  {
    path: "/admin/moderators/:id/edit",
    name: "ModeratorEdit",
    component: () => import("../views/Admin/Users/ModeratorEdit.vue"),
    meta: { requiresAuth: true, permissions: ['edit users', 'edit-users'] }
  },

  // Meeting Management routes
  {
    path: "/meetings",
    name: "MeetingsList",
    component: () => import("../views/Meetings/List.vue"),
    meta: { requiresAuth: true, permissions: ['view meetings', 'view-meetings', 'create meetings', 'create-meetings', 'edit meetings', 'edit-meetings'] }
  },
  {
    path: "/meetings/create",
    name: "MeetingCreate",
    component: () => import("../views/Meetings/MeetingForm.vue"),
    meta: { requiresAuth: true, permissions: ['create meetings', 'create-meetings'] }
  },
  {
    path: "/meetings/:id/edit",
    name: "MeetingEdit",
    component: () => import("../views/Meetings/MeetingForm.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['edit meetings', 'edit-meetings'] }
  },
  {
    path: "/meetings/:id/view",
    name: "MeetingView",
    component: () => import("../views/Meetings/View.vue"), // Assuming View.vue will be created
    props: true,
    meta: { requiresAuth: true, permissions: ['view meetings', 'view-meetings'] }
  },

  // Role Management routes
  {
    path: "/admin/roles",
    name: "RoleManagement",
    component: () => import("../views/Admin/RoleManagement.vue"),
    meta: { requiresAuth: true, permissions: ['view roles', 'view-roles', 'create roles', 'create-roles', 'edit roles', 'edit-roles', 'delete roles', 'delete-roles'] }
  },

  // User Role Assignment routes
  {
    path: "/admin/users/roles",
    name: "UserRoleAssignment",
    component: () => import("../views/Admin/UserRoleAssignment.vue"),
    meta: { requiresAuth: true, permissions: ['assign roles', 'assign-roles', 'view roles', 'view-roles'] }
  },
  {
    path: "/admin/users/roles/:id/edit",
    name: "UserRoleAssignmentEdit",
    component: () => import("../views/Admin/UserRoleAssignment/Edit.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['assign roles', 'assign-roles'] }
  },
  {
    path: "/drive/folder/:folderId",
    name: "FolderView",
    component: () => import("../views/Drive/FolderView.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/drive/file/:fileId",
    name: "FilePlayer",
    component: () => import("../views/Drive/FilePlayer.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/google-channels",
    name: "GoogleChannels",
    component: () => import("../views/GoogleChannels.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/facebook-pages",
    name: "FacebookPages",
    component: () => import("../views/FacebookPages.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/tiktok-accounts",
    name: "TikTokAccounts",
    component: () => import("../views/TikTokAccounts.vue"),
    meta: { requiresAuth: true },
  },
];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

export default router;
